import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useSyncSearcherPackages } from '../../../hooks/api/backfills/useSyncSearcherPackages';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';
import Text from '../../generic/Text';

/**
 * Shows a button to trigger sync of Python and Swift packages.
 */
export const SyncSearcherPackages: VoidFunctionComponent = () => {
  const { mutate: syncSearcherPackages, isPending } = useSyncSearcherPackages();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Sync Searcher Packages',
      body: (
        <div>
          Are you sure you want to sync Python and Swift packages?
        </div>
      ),
      onConfirm: async () => {
        syncSearcherPackages();
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Sync Searcher Packages</Card.Header>
      <Card.Content>
        <Text.Paragraph>
          This will queue background jobs that sync Python and Swift packages (for manual deps auto-complete).
        </Text.Paragraph>
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Sync
        </Button>
      </Card.Content>
    </Card>
  );
};

export default SyncSearcherPackages;
